module.exports = __webpack_public_path__ + "static/media/icon-pdf.dd06e80d.svg";